/* Fest Flags product page clean-up (Todd 2026-10-15, 🌐 WEBSITE "Product page clean-up").
 * LOOK ONLY. Every control here sets the page's EXISTING fields (the theme's size/sides pickers and the
 * Infinite Options selects) exactly as a customer would, so the cart line, the order and Tina's sheet see
 * the same values as before. Nothing is posted to the cart from here: the sticky bar clicks the real
 * Add to cart button. If anything is missing, that part is skipped and the classic control stays visible.
 * Loaded on the pages layout/theme.liquid renders snippets/ff-pdp-clean.liquid for (round 1, 2026-10-16: custom-flags,
 * custom-atv-utv-whip-flags-rectangle, custom-music-festival-flags; round 2, 2026-10-19: custom-boat-flags, custom-motorcycle-flags,
 * custom-cheer-leading-and-field-runner-flags); each needs a settings block in PAGES below. Club flags 2026-11-02: every product
 * tagged club, via the '#club' block. */
(function () {
  'use strict';
  var D = document;
  // Todd 2026-10-16 (screenshot: "This flag's artwork can't be changed here"): the cart's "Change artwork" opens THIS page with
  // ?ff_art=… (ff-cart.js change mode) and uses Uploadery's own box where the live page has it. In that mode the clean-up steps
  // aside completely (no class, no moved box), so the Change artwork screen gets exactly the live page.
  if (/[?&]ff_art=/.test(window.location.search) || D.documentElement.classList.contains('ff-art-on')) {
    // Cart K2 (Todd 2026-10-21: "Adding an image in the cart does not produce the same count-up timer that we were doing before
    // (the same percentage timer)"): on the Change / Add artwork screen only the upload percentage bar (watchUploads, display only,
    // never touches a field) runs too; Uploadery's box arrives late, so it is looked for every 300 ms for up to 15 s.
    var upTries = 0, upTimer = setInterval(function () {
      if (D.getElementById('uploadery-container') || ++upTries > 50) {
        clearInterval(upTimer);
        try { watchUploads(); } catch (e) { console.warn('[ff-clean] upload percentage bar not started on the artwork screen', e); }
      }
    }, 300);
    return;
  }
  var dataEl = D.getElementById('ff-clean-variants');
  if (!dataEl) return;
  var VARIANTS;
  try { VARIANTS = JSON.parse(dataEl.textContent); } catch (e) { console.warn('[ff-clean] variant data unreadable; classic page kept', e); return; }

  /* ---------- Round 1 (Todd 2026-10-16: "Yes, start round 1: ATV + Festival. Same look first"): one settings block per page.
     A page with no settings here keeps the classic page. ---------- */
  var HANDLE = dataEl.getAttribute('data-handle') || ((/\/products\/([^\/?#]+)/.exec(window.location.pathname) || [])[1] || '');
  var CF_SIZES = ['1 X 2 Feet', '2 X 2 Feet', '2 X 3 Feet', '3 X 4 Feet', '3 X 5 Feet', '4 X 6 Feet'];
  var ATV_WHIP_SMALL = ['8 X 18 Inch Rectangle', '10 X 15 Inch Rectangle', '12 X 18 Inch Rectangle'];
  var ATV_WHIP_BIG = ['16 X 24 Inch Rectangle', '14 X 28 Inch Rectangle'];
  var ATV_FEET = ['2 X 3 Feet', '2.5 X 4 Feet', '3 X 5 Feet'];
  // Todd 2026-10-16 (replaces 2026-10-15): single-sided = 4x always; double-sided 1 x 2 / 2 x 2 = 4x, 2 x 3 / 3 x 4 / 3 x 5 = 6x, 4 x 6 = 8x.
  function recCF(size, sides) {
    if (sides !== 'Double Sided') return '4x';
    if (size === '1 X 2 Feet' || size === '2 X 2 Feet') return '4x';
    if (size === '4 X 6 Feet') return '8x';
    return '6x';
  }
  // Todd 2026-10-16 (round 1 mockups, "Yes"): single-sided 4x on whip sizes, 6x on 2 x 3 ft and up; double-sided 6x on whip sizes,
  // 8x on 2 x 3 ft and up.
  function recWhip(feet, size, sides) {
    var big = feet.indexOf(size) !== -1;
    return sides === 'Double Sided' ? (big ? '8x' : '6x') : (big ? '6x' : '4x');
  }
  function recATV(size, sides) { return recWhip(ATV_FEET, size, sides); }
  var BOAT_INCH = ['8 X 18 Inch Rectangle', '12 X 18 Inch Rectangle', '16 X 24 Inch Rectangle', '14 X 28 Inch Rectangle'];
  var BOAT_FEET = ['2 X 3 Feet', '3 X 5 Feet'];
  var DC_SIZES = ['10 X 15 Inch Rectangle', '12 X 12 Inch Square', '12 X 18 Inch Rectangle', '14 X 20 Inch Rectangle', '16 X 24 Inch Rectangle', '18 X 18 Inch Square', '2 X 3 Feet'];
  var SITE_VEHICLE = { sizes: DC_SIZES, unitOnTile: true, rec: function () { return '4x'; } };
  var TD_SIZES = ['Teardrop - Small (2.66 FT x 6.33 FT)', 'Teardrop - Medium (3.25 FT x 10.16 FT)', 'Teardrop - Large  (4 FT x 12 FT)',
    'Feather - Small (2.25 FT x 6.83 FT)', 'Feather - Medium (2.42 FT x 10.33 FT)', 'Feather - Large (2.58 FT x 13.83 FT)',
    'Rectangle - Small (2.25 FT x 4.92 FT)', 'Rectangle - Medium (2.25 FT x 7.58 FT)', 'Rectangle - Large (2.25 FT x 11.17 FT)'];
  // Todd 2026-10-17: "Shouldn't we say estimated speed rating or approximate speed rating?" -> the label reads "Estimated speed rating:".
  // Speed rating under Size (Todd 2026-10-16: "If they pick 3 X 5 Feet double sided then a little help notes should say for parade
  // speeds 15-20. Can be Too heavy for whip"; table = the draft Todd approved: "Yes"). It follows size + sides only.
  // Todd 2026-10-17: "I probably won't even have a single-sided as a speed rating because a lot of people have different luck with
  // this. We've got guys that were going 90 to 100, and the flags weren't ripping" → double-sided only.
  function speedATV(size, sides) {
    if (sides !== 'Double Sided') return null;
    if (ATV_WHIP_SMALL.indexOf(size) !== -1) return { band: 'highway', text: 'up to highway speeds (45–65 MPH).' };
    // Todd 2026-10-18: "16x24 and 14x28 should he same speed rating as 12x18" -> highway; 2 x 3 ft stays trail
    if (ATV_WHIP_BIG.indexOf(size) !== -1) return { band: 'highway', text: 'up to highway speeds (45–65 MPH).' };
    if (size === '2 X 3 Feet') return { band: 'trail', text: 'trail speeds (up to 45 MPH).' };
    // Todd 2026-10-18: "But i thought the 2.5 x 4 and 3 X 5 Feet Double Sided should say parade/ crawling speeds" -> "parade/crawling speeds (15–20 MPH). Ideal for parked RVs. …"
    // Todd 2026-10-18 (earlier): "Ideal for crawling, parked RVs, & parades. Too heavy for whip on fast moving vehicle." + "We want the 15-20 mph" (replaces:)
    // Todd 2026-10-18: "Should say primarily for campsites, stationary RVs, and parade speeds. Can be too heavy for a whip on a fast-moving vehicle"
    // Todd 2026-10-18: hot tip on 3 x 5 ft double removed ("Yeah, get rid of the hot tip.")
    if (size === '2.5 X 4 Feet' || size === '3 X 5 Feet') return { band: 'parade', warn: true, text: 'parade/crawling speeds (15–20 MPH). Ideal for parked RVs. Too heavy for whip on fast moving vehicle.' };
    return null;
  }
  // Todd 2026-10-19: "Lets omit the stiching help its pointless" -> no "Stitching suggestions" panel on any page (the stitching
  // tiles already say Economical / Recommended / Max)
  // Club flags 2026-11-02 (Todd: "did you configure infinite options for this? It should also have the new sexy-looking product page
  // that we've been using."): club art is finished, so the club's own sets = stitching ("3 MASTER - Extra Stitching?") + finishing and
  // need-by date ("4 FINISHING -MASTER PREMADE DESIGNS NOT USA ( Sleeves )"), no design help, no upload. Stitching rule = Custom Flags'
  // (single 4x; double 4x on the small sizes, 6x on 2 x 3 ft and up). Older club flags keep their 'Rectangle' size names and 2-pack sizes.
  var CLUB_SMALL = ['6 X 9 Inch', '12 X 18 Inch', '6 X 9 Inch Rectangle', '12 X 18 Inch Rectangle', '12 X 18 Inch Pennant', '16 X 24 Inches'];
  var CLUB_FEET = ['2 X 3 Feet', '3 X 5 Feet'];
  function recClub(size, sides) { return sides === 'Double Sided' && CLUB_FEET.indexOf(size) !== -1 ? '6x' : '4x'; }
  var PAGES = {
    '#club': { sizes: CLUB_SMALL.concat(CLUB_FEET), unitOnTile: true, rec: recClub, startSizes: ['12 X 18 Inch', '12 X 18 Inch Rectangle'], fin: 'premade', noPole: true, noArt: true,
      // AUDIT-1 (REJECT): an older club flag sells a 12 x 18 rectangle AND a 12 x 18 pennant; the pennant tile carries a "Pennant" tag and
      // the phone bar says "pennant", so the two never look the same
      tags: { '12 X 18 Inch Pennant': 'Pennant' }, shapeWord: true },
    'custom-flags': { sizes: CF_SIZES, rec: recCF },
    'custom-music-festival-flags': { sizes: CF_SIZES, rec: recCF },
    // Todd 2026-10-17: "Don't we want 12 x 18-inch double-sided to be recommended on the ATV, and then the 16 x 24 should say …
    // larger … The 12 x 18 is like the classic flag size." (12 x 18 double = 40% of ATV flags sold in 365 days) → the page OPENS on
    // 12 x 18 double unless the link names a version (?variant=); tile tags "Classic size" (Todd) and "+78% more flag" (16 x 24 =
    // 384 sq in vs 216; per side +33%, area +78%; agreed in chat)
    'custom-atv-utv-whip-flags-rectangle': { sizes: ATV_WHIP_SMALL.concat(ATV_WHIP_BIG, ATV_FEET), unitOnTile: true, rec: recATV, speed: speedATV,
      start: { size: '12 X 18 Inch Rectangle', sides: 'Double Sided' }, tags: { '12 X 18 Inch Rectangle': 'Classic Size', '16 X 24 Inch Rectangle': '+78% More Flag' },
      // Todd 2026-10-18: "Shouldn't the +78% ONLY appear if 12x18 inch is selected? If they choose anything else it should go away?"
      tagWhen: { '16 X 24 Inch Rectangle': '12 X 18 Inch Rectangle' } },
    // Round 2 (Todd 2026-10-19: "We need to do boat and motorcycle. And cheer."). Each page opens on its best seller (365 days).
    // Boat: stitching like ATV (wind + speed): single 4x inch sizes / 6x on 2 x 3 ft+; double 6x inch sizes / 8x on 2 x 3 ft+.
    'custom-boat-flags': { sizes: BOAT_INCH.concat(BOAT_FEET), unitOnTile: true, rec: function (size, sides) { return recWhip(BOAT_FEET, size, sides); },
      start: { size: '12 X 18 Inch Rectangle', sides: 'Double Sided' } },
    // Cheer: the Custom Flags stitching rule.
    'custom-cheer-leading-and-field-runner-flags': { sizes: ['2 X 2 Feet', '2 X 3 Feet', '3 X 4 Feet', '3 X 5 Feet', '4 X 6 Feet'], rec: recCF,
      start: { size: '3 X 5 Feet', sides: 'Double Sided' } },
    // Motorcycle: its OWN Infinite Options sets: the stitching field is "STITCHING  " (two trailing spaces), levels up to 6x (no
    // 8x); finishing is left-side only with .75-inch sleeves, so no LEFT/RIGHT switch. Todd 2026-10-19: "For motorcycle, I would
    // say that single-sided and double-sided start at 4x for stitching. There's no need for 6x stitching on that small flag."
    'custom-motorcycle-flags': { sizes: ['6 X 9 Inch Rectangle', '9 X 12 Inch Rectangle', '10 X 15 Inch Rectangle', '12 X 18 Inch Rectangle',
      '16 X 24 Inch Rectangle', '14 X 28 Inch Rectangle', '2 X 3 Feet', '3 X 5 Feet'], unitOnTile: true, rec: function () { return '4x'; },
      start: { size: '6 X 9 Inch Rectangle', sides: 'Double Sided' }, stName: 'properties[STITCHING  ]', levels: ['2x', '4x', '6x'],
      fin: 'moto', noPole: true },
    // Round 3 (Todd 2026-10-19: "DO them all. Just refine them. data center is basically same. No need to do suggestions.  golf and
    // teardrop please make nice. Dont change anything else"). No starting version and no pre-picks on these pages beyond the
    // data center stitching rule (each page keeps the default it has today).
    // Data center / site vehicle pages (all 7 in the "site-vehicle-flags" collection): the MASTER option sets, like Boat.
    // Todd 2026-10-19: "the data center one should be applied to all of these. I don't think we ever need to suggest 6x stitching on
    // these. That's a bit too much because they're slow-moving vehicles. I would suggest the 4x." -> 4x pre-picked on every size + sides.
    // Todd changed this product's handle by hand 2026-10-21 (cart-utv-buggy-flags -> worksite-utility-cart-flags); both kept.
    'cart-utv-buggy-flags': SITE_VEHICLE, 'worksite-utility-cart-flags': SITE_VEHICLE, 'numbered-vehicle-flags': SITE_VEHICLE, 'high-visibility-safety-flags': SITE_VEHICLE,
    'custom-logo-site-vehicle-flags': SITE_VEHICLE, 'department-cart-flags': SITE_VEHICLE, 'zone-identification-flags': SITE_VEHICLE,
    'fleet-id-flags': SITE_VEHICLE,
    // Dune pennant: its own sets (Overlock stitching, left-only finishing incl. "Heavy Duty Oxford Sleeve + Rope") -> every choice
    // as a tile (custom: true), nothing pre-picked (Infinite Options' own default stays).
    'whip-flags-and-dune-flags': { sizes: ['12 X 18 Inch Pennant', '16 X 24 Inch Pennant', '24 X 36 Inch Pennant'], unitOnTile: true, rec: null, custom: true,
      tiles: [
        // Todd 2026-10-20: "Overlock stitching upgrade: a tougher, wrapped edge" (Overlock is a different technique, not more rows)
        { name: 'properties[STITCHING]', head: 'Edge stitching', hint: 'Overlock stitching upgrade: a tougher, wrapped edge.', step: '3',
          names: [[/^No - Double/i, '2x standard double stitch'], [/^Overlock Secure Edge/i, 'Overlock Secure Edge Stitching']] }],
      // Todd 2026-10-19: "let's just have the finishing be the two grommets on the left and the two black grommets on the left. You also
      // missed the selector of left and right there, and hide the other options in the little menu like we did before." + "yes" to adding
      // RIGHT choices to the pennant's Infinite Options set -> the finishing tiles of the other pages (2 grommet tiles up front, the rest
      // under "More finishing options") with the LEFT/RIGHT switch, shown only once the set has RIGHT values (`poleIfRight`)
      fin: 'pennant', finClassic: true, poleIfRight: true },
    // Golf: one size ("Size " has a trailing space in Shopify), an 18-pack; its own set ("Stiching:", "Finishing:", "Design:", ...).
    'custom-golf-flag-with-tube-insert': { sizes: ['14 X 20 Inch'], unitOnTile: true, rec: null, custom: true, sizeOpt: 'options[Size ]',
      // Todd 2026-10-19: "It's helpful when it's selected, but when it gets deselected, it should not be there." -> the note shows only
      // while the rotational tube inserts are the finishing
      sizeNote: 'Pack of 18 golf flags with rotational tube inserts.', sizeNoteWhen: { field: 'properties[Finishing:]', re: /^Golf Flag Rotational Tube Inserts/i }, twoArt: true,
      fields: { st: 'properties[Stiching:]', des: 'properties[Design:]', notes: 'properties[Notes for Design Team:]', date: 'properties[Date Needed By:]' },
      tiles: [
        { name: 'properties[Stiching:]', head: 'Edge stitching', hint: 'More rows = increased durability.', step: '3',
          names: [[/^No - Double/i, '2x standard double stitch'], [/^4x Edge Stitching/i, '4x PrecisionLock™']] },
        { name: 'properties[Finishing:]', head: 'Finishing', step: '4',
          names: [[/^Golf Flag Rotational Tube Inserts/i, 'Rotational tube inserts (18-pack, $5.55 each)'], [/^2 Grommets - 1 on each left corner/i, '2 grommets, left corners'],
            [/^\.75 inch diameter pole.*White Oxford Sleeve/i, 'White sleeve + rope, closed top (.75-inch pole)'], [/^\.75 inch diameter pole.*Black Oxford Sleeve/i, 'Black sleeve + rope, closed top (.75-inch pole)'],
            [/^\.5 inch diameter pole.*White Oxford Sleeve/i, 'White sleeve + rope, closed top (.5-inch pole)'], [/^\.5 inch diameter pole.*Black Oxford Sleeve/i, 'Black sleeve + rope, closed top (.5-inch pole)']] }] },
    // Teardrop / feather: ONE Shopify option ("Size & Shape", 3 shapes x 3 sizes) shown as a shape-by-size grid; sides and the
    // pole + base are Infinite Options boxes (shown as tiles).
    'teardrop-flags': { sizes: TD_SIZES, sizeOpt: 'options[Size & Shape]', sidesOpt: null, shapes: true, rec: null, custom: true,
      sidesField: 'properties[# of Sides Printed]', desStep: '4', artStep: '5',
      fields: { des: 'properties[Need Help With Design?]', notes: 'properties[Design Placement Notes]', date: 'properties[Date Needed By]' },
      tiles: [
        { name: 'properties[# of Sides Printed]', head: 'Single-sided or double-sided?', step: '2',
          names: [[/^Single Sided/i, 'Single-sided'], [/^Double Sided/i, 'Double-sided']] },
        // Todd 2026-10-19: "Things that are small need small hardware, medium need to be medium, and large need to be large. If we can make
        // it so those aren't even selectable, that would be best." -> only the pole sets of the flag's size can be picked; a picked set
        // follows a flag-size change (same type, matching size); "Flag only" stays as it is (no paid hardware added unasked)
        // Todd 2026-10-20: "the flag-only no-pole base should be at the bottom ... small is on the top, medium in the middle, and large at the
        // bottom" -> `poleOrder`; "Flag only" stays the pre-checked choice (Infinite Options' default, unchanged)
        { name: 'properties[Pole + Base]', head: 'Pole + base', step: '3', names: [[/^NONE$/i, 'Flag only (no pole or base)']], matchSize: true, poleOrder: true }],
      // Todd 2026-10-20: "it should show the add-ons there at the bottom margin (so there's no sticker shock when you add to cart)" + "the
      // add-ons only show for the advertising flag section" -> the phone bar on THIS page only shows the total with the picked add-ons
      barAddons: ['properties[# of Sides Printed]', 'properties[Pole + Base]', 'properties[Need Help With Design?]'] }
  };
  // Club flags 2026-11-02: a product tagged club (data-page="#club" from the snippet) uses the '#club' block unless its handle has its own
  var PAGE_KEY = Object.prototype.hasOwnProperty.call(PAGES, HANDLE) ? HANDLE : (dataEl.getAttribute('data-page') || HANDLE);
  var PAGE = Object.prototype.hasOwnProperty.call(PAGES, PAGE_KEY) ? PAGES[PAGE_KEY] : null;
  if (!PAGE) { console.warn('[ff-clean] no settings for page "' + HANDLE + '"; classic page kept'); return; }
  // club: opens on the first 12 x 18 the product really has, double-sided (new club flags say "12 X 18 Inch", older ones "12 X 18 Inch Rectangle")
  if (PAGE.startSizes) {
    var startSize = PAGE.startSizes.filter(function (s) { return VARIANTS.some(function (v) { return v.option1 === s && v.option2 === 'Double Sided'; }); })[0];
    PAGE.start = startSize ? { size: startSize, sides: 'Double Sided' } : null;
  }

  // round 3: a page can name its own size option ("Size " on golf, "Size & Shape" on teardrop) and have NO sides option (teardrop)
  var SIZE = PAGE.sizeOpt || 'options[Size]', SIDES = PAGE.sidesOpt === null ? null : (PAGE.sidesOpt || 'options[# of Sides with Image]');
  // round 2: a page can name its own stitching field (motorcycle: "STITCHING  " with two trailing spaces, exactly as Infinite Options has it)
  // round 3: golf / teardrop name their own design, notes and date fields
  var PF = PAGE.fields || {};
  var ST_NAME = PAGE.stName || PF.st || 'properties[STITCHING]', FIN_NAME = 'properties[FINISHING:]', DES_NAME = PF.des || 'properties[DESIGN:]';
  var NOTES_NAME = PF.notes || 'properties[Notes for Design Team]', DATE_NAME = PF.date || 'properties[Date Needed By:]';
  // the field whose arrival means Infinite Options has loaded (stitching on most pages; the first tile box on teardrop)
  var READY_NAME = PAGE.custom && PAGE.tiles && PAGE.tiles.length ? PAGE.tiles[0].name : ST_NAME;
  var SIDE_TEXT = {
    'Single Sided': ['Single-sided', 'Front side print. Minor see-through elements. Image on the back appears in a reverse format with about 75% to 85% prominence.'],
    'Double Sided': ['Double-sided', '100% image visibility on both sides. No see-through. Can have a different image on either side.']
  };
  // Stitching levels: matched by the START of the live option value, never by a copied string,
  // so the exact Infinite Options value (spaces included) is what gets set.
  var ST = [
    { key: '2x', re: /^No - Double/i, name: '2x standard double stitch', html: '2x standard<span class="ff-desk"> double stitch</span>' },
    { key: '4x', re: /^4x Edge Stitching/i, name: '4x PrecisionLock™' },
    { key: '6x', re: /^6x Edge Stitching/i, name: '6x PrecisionLock™' },
    { key: '8x', re: /^8x Edge Stitching/i, name: '8x PrecisionLock™' }
  ].filter(function (l) { return (PAGE.levels || ['2x', '4x', '6x', '8x']).indexOf(l.key) !== -1; });
  // round 2: the "Max" tag + line go on the page's TOP level (8x, or 6x on the motorcycle page)
  var ST_TOP = ST[ST.length - 1].key;
  // Known values (audit 2): the pre-pick and the buttons only run on what they were built for; anything else = classic page.
  var KNOWN_SIZES = PAGE.sizes;
  var KNOWN_SIDES = ['Single Sided', 'Double Sided'];
  var warned = {};
  function warnOnce(k, msg) { if (!warned[k]) { warned[k] = 1; console.warn('[ff-clean] ' + msg); } }
  var state = { lastVariantKey: null, uiOk: false, pole: null };

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  // audit 3: prices are shown in the SHOPPER'S currency. price_text comes from Shopify's own money filter (same as the
  // theme's price); a difference ("+…" on the sides button) is formatted with the shopper's active currency.
  function isUSD() { var c = window.Shopify && Shopify.currency && Shopify.currency.active; return !c || c === 'USD'; }
  // add-on price from the Infinite Options value; shown as "+$" only to USD shoppers (audits 4-5: others are charged in their currency)
  function addonPrice(v) { var m = String(v).match(/\{\s*\+?\s*\$?\s*([\d.]+)\s*\}/); return m ? (isUSD() ? '+$' + m[1] : '') : 'Included'; }
  function priceText(v) { return v && typeof v.price_text === 'string' ? v.price_text : ''; }
  function moneyDiff(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || null;
    if (!cur || !window.Intl || !Intl.NumberFormat) return '';
    try { return new Intl.NumberFormat(D.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return ''; }
  }
  // sizes read as "3 X 5 Feet" / "12 X 18 Inch Rectangle"; anything else is shown exactly as Shopify has it
  function sizeParts(v) { var m = /^([\d.]+)\s*X\s*([\d.]+)\s*(Feet|Inch)\b/i.exec(String(v)); return m ? { a: m[1], b: m[2], u: /^f/i.test(m[3]) ? 'ft' : 'in' } : null; }
  // round 3 (teardrop): "Feather - Medium (2.42 FT x 10.33 FT)" -> shape Feather, size Medium, dim "2.42 × 10.33 ft"
  function shapeParts(v) { var m = /^\s*(\w+)\s*-\s*(Small|Medium|Large)\s*\(\s*([\d.]+)\s*FT\s*x\s*([\d.]+)\s*FT\s*\)/i.exec(String(v)); return m ? { shape: m[1], size: m[2], dim: m[3] + ' × ' + m[4] + ' ft' } : null; }
  function sizeShort(v) { var p = sizeParts(v); return p ? p.a + ' × ' + p.b + (PAGE.unitOnTile ? ' ' + p.u : '') : String(v); }
  function sizeLabel(v) { var p = sizeParts(v); return p ? p.a + ' × ' + p.b + ' ' + p.u + (PAGE.shapeWord && /pennant/i.test(v) ? ' pennant' : '') : String(v); }
  // a size tile's tag; one with a tagWhen shows only while that size is the one picked
  function tagFor(size, picked) {
    var t = PAGE.tags && PAGE.tags[size];
    if (!t) return null;
    if (PAGE.tagWhen && PAGE.tagWhen[size] && picked !== PAGE.tagWhen[size]) return null;
    return t;
  }
  function vsSelect(name) {
    var all = D.querySelectorAll('variant-selects select');
    for (var i = 0; i < all.length; i++) if (all[i].name === name) return all[i];
    return null;
  }
  function ioField(name) {
    var c = D.getElementById('infiniteoptions-container'); if (!c) return null;
    var all = c.querySelectorAll('[name]');
    for (var i = 0; i < all.length; i++) if (all[i].name === name) return all[i];
    return null;
  }
  function cur() { var a = vsSelect(SIZE), b = vsSelect(SIDES); return { size: a && a.value, sides: b && b.value }; }
  function variantFor(size, sides) {
    for (var i = 0; i < VARIANTS.length; i++) if (VARIANTS[i].option1 === size && VARIANTS[i].option2 === sides) return VARIANTS[i];
    return null;
  }
  function fire(el) { el.dispatchEvent(new Event('input', { bubbles: true })); el.dispatchEvent(new Event('change', { bubbles: true })); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function refocus(root, v) { var b = root.querySelectorAll('button[data-ff-value]'); for (var i = 0; i < b.length; i++) if (b[i].getAttribute('data-ff-value') === v) { b[i].focus(); return; } }

  /* ---------- round 1 start-up: the page OPENS on PAGE.start (ATV 12 x 18 double). Fixed 2026-10-17 (page-check run5 blocker:
     the tiles showed 12 x 18 double while the Add to cart form kept 8 x 18 single). The theme (global.js VariantSelects) looks the
     version up from the `selected` mark on EVERY picker but moves that mark only on the picker that fired, so both marks are
     moved here first, and only once the theme's own pieces are defined. Then the result is CHECKED: the theme disables Add to
     cart the moment it starts its look-up; if it did not, or the form does not end up holding the starting version, the pickers
     go back to what the form really holds. The page never shows a pick the form does not have.
     Audit 3 (REJECT, one corrective pass): (1) the tiles/sticky bar are redrawn AT ONCE after the start-up (and after a tap), while
     the theme holds Add to cart off, so they never lag the form; (2) a look-up slower than 8 s, or one that failed, is ABORTED
     (the theme's own abortController, so no late answer can land) and the page goes back to its own default with Add to cart on;
     (3) if the theme already blanked the form (error / bot-check answer), the page reloads once on its own default
     (?variant=, server-rendered, so it can never disagree). ---------- */
  function markPick(sel, value) {
    sel.value = value;
    if (sel.value !== value) return false;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === value) sel.options[i].setAttribute('selected', 'selected'); else sel.options[i].removeAttribute('selected');
    }
    return true;
  }
  function formId() { var i = D.querySelector('product-form form[action*="/cart/add"] [name="id"]'); return i ? String(i.value) : ''; }
  function formButton() { return D.querySelector('product-form form[action*="/cart/add"] [type="submit"]'); }
  function variantById(id) { for (var i = 0; i < VARIANTS.length; i++) if (String(VARIANTS[i].id) === String(id)) return VARIANTS[i]; return null; }
  // audit 3: stop the start-up look-up and put the page back on the version the form holds (the server-rendered default)
  function recoverStart(before, why) {
    var pi = D.querySelector('product-info');
    try { if (pi && pi.abortController) pi.abortController.abort(); } catch (e) {}
    warnOnce('start', 'start-up undone (' + why + ')');
    var id = formId(), v = variantById(id), a = vsSelect(SIZE), b = vsSelect(SIDES);
    if (!v || !a || !b) {   // the theme blanked the form (error / bot-check answer): reload once on the page's own default
      try { window.location.replace(window.location.pathname + '?variant=' + encodeURIComponent(before)); } catch (e) {}
      return;
    }
    markPick(a, v.option1); markPick(b, v.option2);
    var pf = D.querySelector('product-info product-form');
    if (id === String(before) && v.available !== false && pf && typeof pf.toggleSubmitButton === 'function') pf.toggleSubmitButton(false);
    applyAll();
  }
  function startUp() {
    if (/[?&]variant=/.test(window.location.search)) return;
    var sv = variantFor(PAGE.start.size, PAGE.start.sides);
    if (!sv || sv.available === false || !window.customElements || !customElements.whenDefined || !window.Promise) return;
    var late = false, lt = setTimeout(function () { late = true; }, 8000);
    Promise.all([customElements.whenDefined('variant-selects'), customElements.whenDefined('product-info'), customElements.whenDefined('product-form')]).then(function () {
      clearTimeout(lt);
      if (late || state.touched) return;   // never move a page the shopper has already used
      var a = vsSelect(SIZE), b = vsSelect(SIDES), btn = formButton(), before = formId();
      if (!a || !b || !btn || !before) { warnOnce('start', 'start-up skipped: theme pickers or form not found'); return; }
      if (a.value === PAGE.start.size && b.value === PAGE.start.sides) return;
      var oldA = a.value, oldB = b.value;
      var back = function (why) { markPick(a, oldA); markPick(b, oldB); warnOnce('start', 'start-up undone (' + why + '); page left on its own default'); applyAll(); };
      if (!markPick(a, PAGE.start.size) || !markPick(b, PAGE.start.sides)) { back('starting version not in the pickers'); return; }
      var wasOff = btn.hasAttribute('disabled');
      fire(b);
      if (!wasOff && !btn.hasAttribute('disabled')) { back('the theme did not start a look-up'); return; }
      applyAll();   // audit 3 (1): tiles + sticky bar show the start NOW, while the theme holds Add to cart off
      var t0 = Date.now(), iv = setInterval(function () {
        var id = formId();
        if (state.touched) { clearInterval(iv); return; }   // the shopper took over; the theme follows their tap
        if (id === String(sv.id)) { clearInterval(iv); applyAll(); return; }
        if (id !== String(before) || Date.now() - t0 > 8000) { clearInterval(iv); recoverStart(before, 'form holds ' + (id || 'nothing') + ' after ' + (Date.now() - t0) + ' ms'); }
      }, 50);
    });
  }

  /* ---------- 2. Size + sides as tap buttons (drive the theme's own pickers) ---------- */
  function renderVariantUI() {
    var vs = D.querySelector('variant-selects'), sizeSel = vsSelect(SIZE), sideSel = SIDES ? vsSelect(SIDES) : null;
    if (!vs || !sizeSel || (SIDES && !sideSel)) return false;
    // round 1: the page's starting version (once per page load, only when the link names no version); see startUp() below.
    if (PAGE.start && !state.startDone) { state.startDone = true; startUp(); }
    var c = cur();
    // audit 2: if the buttons cannot find the product version for what is picked (e.g. the options were reordered or
    // renamed in Shopify admin), take the buttons away and give the customer the theme's own size/sides pickers back.
    if (!variantFor(c.size, c.sides)) {
      warnOnce('variant', 'no product version matches "' + c.size + '" / "' + c.sides + '" in the button data; classic size/sides pickers kept');
      var old = D.getElementById('ff-variant-ui'); if (old) old.parentNode.removeChild(old);
      D.documentElement.classList.remove('ff-v-ready');
      state.uiOk = false;
      return false;
    }
    var box = D.getElementById('ff-variant-ui');
    if (!box) {
      box = D.createElement('div'); box.id = 'ff-variant-ui';
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-ff-name]'); if (!b || b.disabled) return;
        state.touched = true;
        var s = vsSelect(b.getAttribute('data-ff-name')); if (!s || s.value === b.getAttribute('data-ff-value')) return;
        // audit 3: same protection as the start-up. The theme turns Add to cart off the moment it starts a look-up; if it did
        // not (theme not ready yet), the tap is undone so the tiles never show a pick the form does not have. Otherwise the
        // tiles + sticky bar are redrawn AT ONCE (Add to cart is off until the theme has the new version).
        var old = s.value, btn = formButton(), wasOff = !btn || btn.hasAttribute('disabled');
        s.value = b.getAttribute('data-ff-value'); fire(s);
        if (!wasOff && !btn.hasAttribute('disabled')) { markPick(s, old); warnOnce('tap', 'the theme did not take a size/sides tap; tap undone'); }
        applyAll();
      });
    }
    if (box.nextElementSibling !== vs) vs.parentNode.insertBefore(box, vs);
    var key = c.size + '|' + c.sides;
    if (box.getAttribute('data-key') !== key) {
      var sizes = [].map.call(sizeSel.options, function (o) { return o.value; });
      var sides = sideSel ? [].map.call(sideSel.options, function (o) { return o.value; }) : [];
      // round 1: shown smallest to largest in the page's own order (display only; the theme's picker keeps Shopify's order);
      // a size the settings do not know stays, after the known ones, in Shopify's order
      var rank = function (s) { var i = PAGE.sizes.indexOf(s); return i === -1 ? 1000 + sizes.indexOf(s) : i; };
      var shown = sizes.slice().sort(function (a, b) { return rank(a) - rank(b); });
      // v4 (Todd 2026-10-16, mockups "guided steps"): each question is a numbered card
      var h;
      if (PAGE.shapes) {
        // round 3 (teardrop, Todd "please make nice"): one row per shape (Teardrop / Feather / Rectangle), Small / Medium / Large
        // tiles with the real size and price. Each tile sets the theme's own "Size & Shape" picker to that exact value.
        h = '<div class="ff-field ff-card"><p class="ff-h" data-ff-step="1">Shape &amp; size</p>';
        var groups = [], byShape = {};
        shown.forEach(function (s) {
          var m = shapeParts(s), g = m ? m.shape : 'Other';
          if (!byShape[g]) { byShape[g] = []; groups.push(g); }
          byShape[g].push(s);
        });
        groups.forEach(function (g) {
          h += '<p class="ff-shape-h">' + esc(g) + '</p><div class="ff-size-grid ff-shape-grid">';
          byShape[g].forEach(function (s) {
            var v = variantFor(s, c.sides), on = s === c.size, m = shapeParts(s);
            h += '<button type="button" class="ff-opt' + (on ? ' ff-on' : '') + '" aria-pressed="' + on + '" data-ff-name="' + esc(SIZE) + '" data-ff-value="' + esc(s) + '"' +
              (v && v.available !== false ? '' : ' disabled') + '><b>' + esc(m ? m.size : s) + '</b>' + (m ? '<span class="ff-dim">' + esc(m.dim) + '</span>' : '') +
              '<span>' + esc(priceText(v)) + '</span></button>';
          });
          h += '</div>';
        });
      } else {
        h = '<div class="ff-field ff-card"><p class="ff-h" data-ff-step="1">Size' + (PAGE.unitOnTile ? '' : ' <span class="ff-h-sub">(feet)</span>') + '</p><div class="ff-size-grid' + (shown.length > 6 ? ' ff-size-many' : '') + '">';
        shown.forEach(function (s) {
          var v = variantFor(s, c.sides), on = s === c.size;
          h += '<button type="button" class="ff-opt' + (on ? ' ff-on' : '') + '" aria-pressed="' + on + '" data-ff-name="' + esc(SIZE) + '" data-ff-value="' + esc(s) + '"' +
            (v && v.available !== false ? '' : ' disabled') + '><b>' + esc(sizeShort(s)) + '</b><span>' + esc(priceText(v)) + '</span>' +
            (tagFor(s, c.size) ? '<em class="ff-size-tag">' + esc(tagFor(s, c.size)) + '</em>' : '') + '</button>';
        });
        h += '</div>';
        // round 3: golf is sold as an 18-pack (one size): say so under the size
        if (PAGE.sizeNote) h += '<p class="ff-size-note">' + esc(PAGE.sizeNote) + '</p>';
      }
      var sp = PAGE.speed ? PAGE.speed(c.size, c.sides) : null;
      // Todd 2026-10-17: "u have speed estimate 2x on some of these. Just say Estimated and have a little thin swoosh under it"
      // -> "estimate" once (the label), with a thin swoosh under it.
      if (sp) h += '<div class="ff-speed' + (sp.warn ? ' ff-speed-warn' : '') + '" role="note"><p><b><span class="ff-est">Estimated<svg class="ff-swoosh" viewBox="0 0 120 6" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path d="M1 4.6C32 0.8 76 0.8 119 3.2"/></svg></span> speed rating:</b> ' + esc(sp.text) + '</p>' +
        // Todd 2026-10-17: "Skip the wind, sun, and rain. That's just pointless banter." -> no conditions line.
        // Todd 2026-10-18: "The swoosh should be under estimated" -> the swoosh is drawn under the word "Estimated" in the label.
        '</div>';
      // round 3: a page with no sides option (teardrop: sides are an Infinite Options box, shown as tiles further down) gets no sides card
      if (!sideSel) h += '</div>';
      else {
      h += '</div><div class="ff-field ff-card"><p class="ff-h" data-ff-step="2">Single-sided or double-sided?</p><div class="ff-sides">';
      var base = variantFor(c.size, sides[0]);
      // v4 (Todd 2026-10-16: "Shouldn't it just say 'Single/Double-sided' and then have 'What's the difference?' as the only
      // thing there?"): the tile = name + price only; the full wording opens under "What's the difference?"
      var why = '';
      // Todd 2026-10-16 (after publish): "once I click the double-sided, it shouldn't say +14 on that now (because then it looks
      // like it's 55.99 + 14)". The size prices already include what is PICKED, so the picked side says "Included" and the other
      // one shows the difference from it: "+$14.00" on Double while Single is picked, "−$14.00" on Single while Double is picked.
      var picked = variantFor(c.size, c.sides) || base;
      sides.forEach(function (s) {
        var v = variantFor(c.size, s), on = s === c.sides, t = SIDE_TEXT[s] || [s, ''];
        var d = (v && picked) ? v.price - picked.price : 0, dtxt = d ? moneyDiff(Math.abs(d)) : '';
        var price = on || (v && !d) ? '<span class="ff-incl">Included</span>'
          : dtxt ? '<span class="ff-plus' + (d < 0 ? ' ff-minus' : '') + '">' + (d < 0 ? '−' : '+') + esc(dtxt) + '</span>' : '';
        h += '<button type="button" class="ff-opt ff-opt-wide' + (on ? ' ff-on' : '') + '" aria-pressed="' + on + '" data-ff-name="' + esc(SIDES) + '" data-ff-value="' + esc(s) + '"' +
          (v && v.available !== false ? '' : ' disabled') + '><b>' + esc(t[0]) + '</b>' + price + '</button>';
        if (t[1]) why += '<p><b>' + esc(t[0]) + ':</b> ' + esc(t[1]) + '</p>';
      });
      var wasOpen = !!(box.querySelector('.ff-why') && box.querySelector('.ff-why').open);
      h += '</div>' + (why ? '<details class="ff-why"' + (wasOpen ? ' open' : '') + '><summary>What’s the difference?</summary><div class="ff-why-body">' + why + '</div></details>' : '') + '</div>';
      }
      var f1 = D.activeElement && box.contains(D.activeElement) ? D.activeElement.getAttribute('data-ff-value') : null;
      box.innerHTML = h; box.setAttribute('data-key', key);
      if (f1 !== null) refocus(box, f1);   // audit 1: keyboard focus stays on the button just picked
    }
    D.documentElement.classList.add('ff-v-ready');
    state.uiOk = true;
    return true;
  }

  /* ---------- 3. Stitching rows (set the Infinite Options STITCHING select) ---------- */
  function stitchValue(sel, level) {
    for (var i = 0; i < sel.options.length; i++) if (level.re.test(sel.options[i].value)) return sel.options[i].value;
    return null;
  }
  function recKey() {
    if (!PAGE.rec) return null;   // round 3: pages with no stitching rule keep today's default (no pre-pick, no tags)
    var c = cur(); if (!c.size || !c.sides) return null;
    // audit 2: only the 6 known sizes and 2 known sides get a pre-pick; a renamed value gets none (and a warning)
    if (KNOWN_SIZES.indexOf(c.size) === -1 || KNOWN_SIDES.indexOf(c.sides) === -1) {
      warnOnce('rec', 'unknown size/sides "' + c.size + '" / "' + c.sides + '"; no stitching pre-pick, no Recommended tag');
      return null;
    }
    // the page's own rule (round 1 settings above: Custom Flags / Festival = Todd 2026-10-16 rule, ATV = round 1 rule)
    return PAGE.rec(c.size, c.sides);
  }
  // Todd 2026-10-16: every size/sides change puts the stitching back to that size's default ("then they can always
  // change it if they want to"); a customer's pick stays until they change size or sides again.
  function applyRecommended() {
    var sel = ioField(ST_NAME), k = recKey(); if (!sel || !k) return;
    var lvl = ST.filter(function (l) { return l.key === k; })[0], v = stitchValue(sel, lvl);
    if (v && sel.value !== v) { sel.value = v; fire(sel); }
  }
  function renderStitch() {
    var sel = ioField(ST_NAME); if (!sel) return;
    var vals = ST.map(function (l) { return stitchValue(sel, l); });
    if (vals.indexOf(null) !== -1) { console.warn('[ff-clean] a stitching level is missing; classic dropdown kept'); return; }
    var field = sel.closest('[class*="spb-io-field"]'); if (!field) return;
    // audit 3: the Recommended / Economical tags show only when the pre-pick can really run (buttons working)
    var rk = state.uiOk ? recKey() : null, econ = rk === '8x' ? '6x' : rk === '6x' ? '4x' : rk === '4x' ? '2x' : null;
    var key = rk + '|' + sel.value;
    var rows = field.querySelector('.ff-stitch');
    if (!rows) {
      rows = D.createElement('div'); rows.className = 'ff-stitch'; rows.setAttribute('role', 'radiogroup');
      rows.setAttribute('data-ff-proxy-for', ST_NAME);
      field.appendChild(rows);
      // Buttons, not radio inputs: they carry no name, so they never become a form field.
      rows.addEventListener('click', function (e) {
        var r = e.target.closest('button[data-ff-value]'); if (!r) return;
        var s = ioField(ST_NAME); if (!s) return;
        var v = r.getAttribute('data-ff-value');
        if (s.value !== v) { s.value = v; fire(s); }
        renderStitch();
      });
      sel.addEventListener('change', function () { renderStitch(); });
    }
    var label = field.querySelector('label');
    // v4 (Todd 2026-10-16): "I think we should call it PrecisionLock Edge Stitching" · "just say 'more rows = increased durability.'"
    setText(label, 'PrecisionLock™ Edge Stitching');
    if (label && !field.querySelector('.ff-hint')) {
      var p = D.createElement('p'); p.className = 'ff-hint';
      p.textContent = 'More rows = increased durability.';
      label.insertAdjacentElement('afterend', p);
    }
    field.classList.add('ff-card'); if (label) label.setAttribute('data-ff-step', '3');
    if (rows.getAttribute('data-key') !== key) {
      var h = '';
      ST.forEach(function (l, i) {
        var v = vals[i], on = sel.value === v, m = v.match(/\{\s*\$([\d.]+)\s*\}/);
        var tag = (l.key === rk ? '<span class="ff-tag ff-tag-rec">Recommended</span>' : l.key === econ ? '<span class="ff-tag ff-tag-econ">Economical</span>' : '') +
          (l.key === ST_TOP ? (l.key === rk ? ' ' : '') + '<span class="ff-tag ff-tag-max">Max</span>' : '');
        var line = l.key === ST_TOP ? 'Our toughest PrecisionLock™ stitching.' : l.key === rk ? 'Most popular configuration.' : '';
        h += '<button type="button" role="radio" aria-checked="' + on + '" class="ff-row' + (on ? ' ff-on' : '') + '" data-ff-value="' + esc(v) + '">' +
          '<span class="ff-dot" aria-hidden="true"></span>' +
          '<span class="ff-row-main"><b>' + (l.html || esc(l.name)) + '</b> ' + tag + (line ? '<span class="ff-sub">' + line + '</span>' : '') + '</span>' +
          '<span class="ff-row-price">' + esc(addonPrice(v)) + '</span></button>';
      });
      var f2 = D.activeElement && rows.contains(D.activeElement) ? D.activeElement.getAttribute('data-ff-value') : null;
      rows.innerHTML = h; rows.setAttribute('data-key', key);
      if (f2 !== null) refocus(rows, f2);
    }
    // round 1 (Todd 2026-10-16: "the Precision Lock … hard to read on the heading … 'Precision' with a capital P … the only thing
    // that should be capitalized should be the Lock"): this one heading is not shown in capitals
    if (label) label.classList.add('ff-h-plain');
    // Todd 2026-10-19: no "Stitching suggestions" panel (removed); an old one is taken away
    [].forEach.call(field.querySelectorAll('.ff-st-help'), function (n) { n.parentNode.removeChild(n); });
    // Todd 2026-10-18: the below-recommended nudge removed ("Get rid of the \"we recommend 6x\" nudge."); an old one is taken away
    [].forEach.call(field.querySelectorAll('.ff-st-nudge'), function (n) { n.parentNode.removeChild(n); });
    field.classList.add('ff-st-ready');
  }

  /* ---------- 3a. Finishing: the two common choices up front, the rest one tap away, plus a pole-side switch
     (Todd 2026-10-16: "99% of people are just going to do the grommets, probably either black or regular ... we need to
     list all the options, but it doesn't need to be such a clusterfuck"). Every tile + side sets the EXACT existing
     Infinite Options value, matched by its start, never typed by hand. Anything unrecognised = classic dropdown kept. ---------- */
  var FIN = [
    { k: 'g2', re: /^2 Grommets - 1 on each (left|right) corner/i, name: '2\u00a0ClawGrip™ Grommets', sub: 'One in each corner on the pole side', common: true },
    { k: 'g2b', re: /^2 Black Grommets - 1 on each\s+(left|right) corner/i, name: '2\u00a0Black ClawGrip™ Grommets', sub: 'One in each corner on the pole side', common: true },
    // Todd 2026-10-19: "On all 4 Grommets option needs to say 4 Grommets - 1 on each corner" (tile text only; the order value is unchanged)
    { k: 'g4', re: /^4 Grommets - 1 in each corner/i, name: '4\u00a0Grommets - 1 on each corner', sub: 'One in every corner', noSide: true },
    { k: 'slw', re: /^Heavy Duty Oxford Sleeve - (LEFT|RIGHT) - WHITE/i, name: 'Oxford sleeve, white', sub: 'Heavy-duty pole sleeve' },
    { k: 'slb', re: /^Heavy Duty Oxford Sleeve - (LEFT|RIGHT) - BLACK/i, name: 'Oxford sleeve, black', sub: 'Heavy-duty pole sleeve' },
    { k: 'gsw', re: /^2 Grommets ON White Sleeve (Left|Right)/i, name: '2 grommets on a white sleeve', sub: 'Sleeve plus grommets' },
    { k: 'gsb', re: /^2 Black Grommets on Black Sleeve on (left|right)/i, name: '2 black grommets on a black sleeve', sub: 'Sleeve plus grommets' }
  ];
  // round 2: the motorcycle page's own finishing list ("MOTO FINISHING" set): left side only, .75-inch Oxford sleeves instead of
  // the heavy-duty ones. Same tiles; `side: 'L'` for values that do not name a side; no LEFT/RIGHT switch (PAGE.noPole).
  if (PAGE.fin === 'moto') {
    FIN = FIN.map(function (c) {
      // Todd 2026-10-19: "Motorcycle should show .75 inch black oxford sleeve and .75 inch white oxford sleeve as 2 options under the
      // grommets that are shown. So people can select right away not hidden in that menu." -> both sleeves are up-front tiles (black first)
      if (c.k === 'slw') return { k: 'slw', re: /^\.75 inch - WHITE Oxford Sleeve/i, side: 'L', name: '.75 inch white Oxford sleeve', sub: 'Pole sleeve', common: true };
      if (c.k === 'slb') return { k: 'slb', re: /^\.75 inch - BLACK Oxford Sleeve/i, side: 'L', name: '.75 inch black Oxford sleeve', sub: 'Pole sleeve', common: true };
      return c;
    });
    var iw = -1, ib = -1;
    FIN.forEach(function (c, i) { if (c.k === 'slw') iw = i; if (c.k === 'slb') ib = i; });
    if (iw !== -1 && ib !== -1 && iw < ib) { var tw = FIN[iw]; FIN[iw] = FIN[ib]; FIN[ib] = tw; }
  }
  // pennant ("Pennant whip set only"): 2 grommets / 2 black grommets (LEFT, and RIGHT once added), 2 grommet-on-sleeve choices, and two
  // "Heavy Duty Oxford Sleeve + Rope" values that name no side (shown for either pole side); no 4-grommet value in this set
  if (PAGE.fin === 'pennant') {
    FIN = FIN.filter(function (c) { return c.k !== 'g4'; }).map(function (c) {
      if (c.k === 'slw') return { k: 'slw', re: /^Heavy Duty Oxford Sleeve \+ Rope - WHITE/i, noSide: true, name: 'Oxford sleeve + rope, white', sub: 'Heavy-duty pole sleeve with rope' };
      if (c.k === 'slb') return { k: 'slb', re: /^Heavy Duty Oxford Sleeve \+ Rope - BLACK/i, noSide: true, name: 'Oxford sleeve + rope, black', sub: 'Heavy-duty pole sleeve with rope' };
      return c;
    });
  }
  // club flags ("4 FINISHING -MASTER PREMADE DESIGNS NOT USA ( Sleeves )"): left side only, all 4 grommet choices, and two
  // "Heavy Duty Oxford Sleeve + Rope" values that name no side; no LEFT/RIGHT switch (PAGE.noPole)
  if (PAGE.fin === 'premade') {
    FIN = FIN.map(function (c) {
      if (c.k === 'slw') return { k: 'slw', re: /^Heavy Duty Oxford Sleeve \+ Rope - WHITE/i, noSide: true, name: 'Oxford sleeve + rope, white', sub: 'Heavy-duty pole sleeve with rope' };
      if (c.k === 'slb') return { k: 'slb', re: /^Heavy Duty Oxford Sleeve \+ Rope - BLACK/i, noSide: true, name: 'Oxford sleeve + rope, black', sub: 'Heavy-duty pole sleeve with rope' };
      return c;
    });
  }
  function finMap(sel) {
    var map = {}, ok = true;
    [].forEach.call(sel.options, function (o) {
      var v = o.value, hit = null, m = null;
      for (var i = 0; i < FIN.length && !hit; i++) { m = v.match(FIN[i].re); if (m) hit = FIN[i]; }
      if (!hit) { ok = false; warnOnce('fin-' + v, 'finishing value not recognised: "' + v + '"; classic dropdown kept'); return; }
      var side = hit.noSide ? 'B' : hit.side ? hit.side : (m[1].charAt(0).toUpperCase() === 'L' ? 'L' : 'R');
      map[hit.k] = map[hit.k] || {};
      if (map[hit.k][side]) { ok = false; warnOnce('fin-dup-' + hit.k + side, 'two finishing values for ' + hit.k + ' ' + side + '; classic dropdown kept'); }
      map[hit.k][side] = v;
    });
    FIN.forEach(function (c) { if (!map[c.k]) ok = false; });
    return ok ? map : null;
  }
  function finOf(map, v) {
    for (var k in map) for (var sd in map[k]) if (map[k][sd] === v) return { k: k, side: sd };
    return null;
  }
  function finValue(map, k, side) { var c = map[k]; return c ? (c.B || c[side] || null) : null; }
  function renderFinish() {
    var sel = ioField(FIN_NAME); if (!sel) return false;
    var field = sel.closest('[class*="spb-io-field"]'); if (!field) return false;
    var map = finMap(sel); if (!map) return false;
    var curF = finOf(map, sel.value); if (!curF) return false;
    if (curF.side !== 'B') state.pole = curF.side;
    var pole = state.pole || 'L';
    var box = field.querySelector('.ff-fin');
    if (!box) {
      box = D.createElement('div'); box.className = 'ff-fin'; box.setAttribute('data-ff-proxy-for', FIN_NAME);
      field.appendChild(box);
      box.addEventListener('click', function (e) {
        var s = ioField(FIN_NAME), mp = s && finMap(s); if (!mp) return;
        var b = e.target.closest('button'); if (!b || b.disabled) return;
        var now = finOf(mp, s.value) || { k: 'g2', side: 'L' }, v = null, isPole = b.hasAttribute('data-ff-pole');
        if (isPole) {
          state.pole = b.getAttribute('data-ff-pole');
          v = finValue(mp, now.k, state.pole);              // re-apply the picked finishing on the other side
        } else if (b.hasAttribute('data-ff-fin')) {
          v = finValue(mp, b.getAttribute('data-ff-fin'), state.pole || 'L');
        }
        var hadFocus = D.activeElement === b, which = isPole ? 'button[data-ff-pole="' + state.pole + '"]' : 'button[data-ff-fin="' + b.getAttribute('data-ff-fin') + '"]';
        if (v && s.value !== v) { s.value = v; fire(s); }
        renderFinish();
        var again = box.querySelector(which); if (again && hadFocus) again.focus();
      });
      sel.addEventListener('change', function () { renderFinish(); });
    }
    // pennant L/R (2026-10-20): the key also carries the list of choices, so a list that changes (e.g. RIGHT values added) redraws
    var key = sel.value + '|' + pole + '|' + isUSD() + '|' + [].map.call(sel.options, function (o) { return o.value; }).join('¦');
    if (box.getAttribute('data-key') !== key) {
      var cur1 = FIN.filter(function (c) { return c.k === curF.k; })[0];
      var keepOpen = !!(box.querySelector('details') && box.querySelector('details').open);
      var tile = function (c) {
        var v = finValue(map, c.k, pole), on = c.k === curF.k;
        return '<button type="button" role="radio" aria-checked="' + on + '" class="ff-row ff-fin-tile' + (on ? ' ff-on' : '') + '" data-ff-fin="' + c.k + '"' + (v ? '' : ' disabled title="Not available on this side"') + '>' +
          '<span class="ff-dot" aria-hidden="true"></span><span class="ff-row-main"><b>' + esc(c.name) + '</b></span>' +
          '<span class="ff-row-price">' + esc(v ? addonPrice(v) : '') + '</span><span class="ff-sub ff-fin-sub">' + esc(c.sub) + '</span></button>';
      };
      var poleBtn = function (sd, label) {
        var ok = curF.side === 'B' || !!finValue(map, curF.k, sd);
        return '<button type="button" role="radio" aria-checked="' + (pole === sd) + '" class="ff-pole' + (pole === sd ? ' ff-on' : '') + '" data-ff-pole="' + sd + '"' + (ok ? '' : ' disabled') + '>' + label + '</button>';
      };
      // round 2: no LEFT/RIGHT switch on a left-only page (motorcycle)
      var hasRight = Object.keys(map).some(function (k) { return !!map[k].R; });
      box.innerHTML = (PAGE.noPole || (PAGE.poleIfRight && !hasRight) ? '' : '<div class="ff-pole-row"><span class="ff-pole-label">Pole on the</span><span class="ff-pole-switch" role="radiogroup" aria-label="Pole side">' + poleBtn('L', 'LEFT') + poleBtn('R', 'RIGHT')   /* Todd 2026-10-16: "Directional positions of the sleeve need to be in all caps" */ + '</span></div>') +
        '<div class="ff-fin-grid" role="radiogroup" aria-label="Finishing">' + FIN.filter(function (c) { return c.common; }).map(tile).join('') + '</div>' +
        '<details class="ff-more"' + (!cur1.common || keepOpen ? ' open' : '') + '><summary>More finishing options</summary><div class="ff-fin-grid" role="radiogroup" aria-label="More finishing">' +
        FIN.filter(function (c) { return !c.common; }).map(tile).join('') + '</div>' +
        // Todd 2026-10-16: "Sleeve built for a 7/8-inch pole diameter by default unless noted. If they need a different pole diameter, they need to email us right after order." (email: info@, Todd "No, info is fine")
        // round 2: the 7/8-inch line is not shown on the motorcycle page (its sleeves are .75-inch; wording for Todd to confirm)
        (PAGE.fin === 'moto' || PAGE.fin === 'pennant' ? '' : '<p class="ff-sleeve-note">Sleeves are made for a 7/8-inch pole unless noted. Need a different pole size? Email <a href="mailto:info@festflags.com">info@festflags.com</a> right after you order, with your order number.</p>') + '</details>';
      box.setAttribute('data-key', key);
    }
    // Todd 2026-10-16: "this is a great opportunity to talk about the claw grip grommets here" (wording = the playbook's approved ClawGrip line)
    var flabel = field.querySelector('label');
    if (flabel && !field.querySelector('.ff-hint')) {
      var fh = D.createElement('p'); fh.className = 'ff-hint';
      // v4 (Todd 2026-10-16): "Claw grip grommets should say 'Grommets' with the capital G."
      fh.textContent = 'ClawGrip™ Grommets: toothed grommets that grip the fabric instead of just punching a hole.';
      flabel.parentNode.insertBefore(fh, flabel.nextSibling);
    }
    field.classList.add('ff-fin-ready', 'ff-card'); if (flabel) flabel.setAttribute('data-ff-step', '4');
    return true;
  }

  /* ---------- 3t. Round 3 (Todd 2026-10-19: Dune pennant, golf, teardrop): every choice of an Infinite Options dropdown as a
     tile. A tap sets that EXACT existing option (found by its own value, never typed), so the order, the cart line and Tina's
     sheet see the same values as before. Shown name = the option text without its {price}; a page may rename a choice for
     display (`names`). Price = the option's own {…} amount ("+$3.99", "+$2.99 each"); no {…} = no price shown (the text keeps
     any price it carries, e.g. "( $5.55 each)"), never "Included". Nothing is pre-picked: the box keeps Infinite Options'
     own default. Fewer than 2 choices or anything unexpected = the classic dropdown stays. ---------- */
  function tileName(cfg, v) {
    var n = cfg.names || [];
    for (var i = 0; i < n.length; i++) if (n[i][0].test(v)) return n[i][1];
    return String(v).replace(/\{[^}]*\}/g, ' ').replace(/\s+/g, ' ').replace(/[\s\-–]+$/, '').trim();
  }
  function tilePrice(v) {
    var m = String(v).match(/\{\s*\+?\s*\$?\s*([\d.]+)\s*(each)?\s*\}/i);
    return m && isUSD() ? '+$' + m[1] + (m[2] ? ' each' : '') : '';
  }
  // teardrop pole sets: "Small Pole + Ground Stake {…}" -> { size: 'Small', type: 'Ground Stake' }
  function poleParts(v) { var m = /^(Small|Medium|Large)\s+Pole\s*\+\s*(.+?)\s*(\{|$)/i.exec(String(v)); return m ? { size: m[1].toLowerCase(), type: m[2].toLowerCase() } : null; }
  function renderTiles(cfg) {
    var sel = ioField(cfg.name); if (!sel || sel.tagName !== 'SELECT') return;
    var field = sel.closest('[class*="spb-io-field"]'); if (!field || !sel.closest('.spb-option-values')) return;
    var opts = [].filter.call(sel.options, function (o) { return !o.disabled && o.value; });
    if (opts.length < 2 || !sel.options[sel.selectedIndex]) return;
    // matchSize (teardrop): the flag's size class from the picked "Size & Shape"; a picked pole set of another size moves to the same
    // type in the flag's size (or "Flag only" if that type does not exist in that size)
    var flagSize = null;
    if (cfg.matchSize) {
      var spf = shapeParts(cur().size); flagSize = spf ? spf.size.toLowerCase() : null;
      var pp = poleParts(sel.value);
      if (flagSize && pp && pp.size !== flagSize) {
        var to = opts.filter(function (o) { var q = poleParts(o.value); return q && q.size === flagSize && q.type === pp.type; })[0] ||
          opts.filter(function (o) { return !poleParts(o.value); })[0];
        if (to && sel.value !== to.value) { sel.value = to.value; fire(sel); }
      }
    }
    var box = field.querySelector('.ff-tiles');
    if (!box) {
      box = D.createElement('div'); box.className = 'ff-fin ff-tiles'; box.setAttribute('data-ff-proxy-for', cfg.name);
      field.appendChild(box);
      // Buttons, not radio inputs: they carry no name, so they never become a form field.
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-ff-value]'); if (!b || b.disabled) return;
        var s2 = ioField(cfg.name), v = b.getAttribute('data-ff-value'); if (!s2) return;
        var hit = [].filter.call(s2.options, function (o) { return o.value === v; })[0]; if (!hit) return;
        if (s2.value !== v) { s2.value = v; fire(s2); }
        renderTiles(cfg); schedule();
        var again = box.querySelector('button[data-ff-value="' + (window.CSS && CSS.escape ? CSS.escape(v) : v) + '"]'); if (again && D.activeElement !== again) again.focus();
      });
      sel.addEventListener('change', function () { renderTiles(cfg); });
    }
    var key = sel.value + '|' + opts.map(function (o) { return o.value; }).join('¦') + '|' + isUSD() + '|' + flagSize;
    if (box.getAttribute('data-key') !== key) {
      var isCommon = function (o) { return !cfg.common || cfg.common.some(function (re) { return re.test(o.value); }); };
      var tile = function (o) {
        var on = o.value === sel.value, pr = tilePrice(o.value), q = cfg.matchSize ? poleParts(o.value) : null, off = !!(q && flagSize && q.size !== flagSize);
        var wide = cfg.poleOrder && !poleParts(o.value);   // "Flag only": last, on a row of its own
        return '<button type="button" role="radio" aria-checked="' + on + '" class="ff-row ff-fin-tile' + (on ? ' ff-on' : '') + (wide ? ' ff-tile-wide' : '') + '" data-ff-value="' + esc(o.value) + '"' +
          (off ? ' disabled title="Fits the ' + esc(q.size) + ' flags only"' : '') + '>' +
          '<span class="ff-dot" aria-hidden="true"></span><span class="ff-row-main"><b>' + esc(tileName(cfg, o.value)) + '</b></span>' +
          '<span class="ff-row-price">' + esc(pr) + '</span></button>';
      };
      var front = opts.filter(isCommon), more = opts.filter(function (o) { return !isCommon(o); });
      if (cfg.poleOrder) {
        var rank = function (o) { var q = poleParts(o.value); if (!q) return 99; return { small: 0, medium: 2, large: 4 }[q.size] + (/crossbase/i.test(q.type) ? 1 : 0); };
        front = front.slice().sort(function (a, b) { return rank(a) - rank(b); });
      }
      var keepOpen = !!(box.querySelector('details') && box.querySelector('details').open), curMore = more.some(function (o) { return o.value === sel.value; });
      var h = '<div class="ff-fin-grid" role="radiogroup" aria-label="' + esc(cfg.head) + '">' + front.map(tile).join('') + '</div>';
      if (more.length) h += '<details class="ff-more"' + (curMore || keepOpen ? ' open' : '') + '><summary>More finishing options</summary><div class="ff-fin-grid" role="radiogroup" aria-label="More ' + esc(cfg.head.toLowerCase()) + '">' + more.map(tile).join('') + '</div></details>';
      box.innerHTML = h; box.setAttribute('data-key', key);
    }
    var lb = field.querySelector('label'); setText(lb, cfg.head);
    if (lb && cfg.step) lb.setAttribute('data-ff-step', cfg.step);
    if (lb && cfg.hint && !field.querySelector('.ff-hint')) {
      var hp = D.createElement('p'); hp.className = 'ff-hint'; hp.textContent = cfg.hint;
      lb.parentNode.insertBefore(hp, lb.nextSibling);
    }
    if (lb) lb.classList.add('ff-h-plain');
    field.classList.add('ff-tiles-ready', 'ff-card');
  }

  /* ---------- 3b. Finishing (fallback only) + design help: the real dropdown on top, full text shown under it ---------- */
  function overlay(name, heading, check, step) {
    var sel = ioField(name); if (!sel) return;
    var wrap = sel.closest('.spb-select'), field = sel.closest('[class*="spb-io-field"]'); if (!wrap || !field) return;
    field.classList.add('ff-card');
    var slabel = field.querySelector('label'); if (slabel && step) slabel.setAttribute('data-ff-step', step);
    var disp = wrap.querySelector('.ff-disp');
    if (!disp) {
      disp = D.createElement('div'); disp.className = 'ff-disp'; disp.setAttribute('aria-hidden', 'true');
      wrap.insertBefore(disp, sel); wrap.classList.add('ff-overlay');
      if (check) wrap.classList.add('ff-settled');
      sel.addEventListener('change', function () { fill(); });
    }
    if (heading) setText(field.querySelector('label'), heading);
    function fill() {
      var t = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : '';
      if (disp.getAttribute('data-t') === t) return;
      // v4 (Todd 2026-10-16: "the design help is on two lines ... That should be on one line if possible"): the box shows the
      // part before " - " only; the real option (and the dropdown list a tap opens) keeps its full text and value
      var i = t.indexOf(' - '), main = check && i > 0 ? esc(t.slice(0, i)) : esc(t);
      disp.innerHTML = (check ? '<svg class="ff-check" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M5 12l5 5L20 7" fill="none" stroke="currentColor" stroke-width="2.5"/></svg>' : '') +
        '<span class="ff-disp-text">' + main + '</span><svg class="ff-chev" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
      disp.setAttribute('data-t', t);
    }
    fill();
  }

  /* ---------- 3c. Design help as an accordion (Todd 2026-10-16 phone/web test: "the design help button is a bit too big,
     and then when it opens, it opens to the old-school menu. I wish it would merge as an accordion. Like the finishing,
     more finishing options reveal"). The picked choice shows settled on one line; one tap opens every choice (name + its
     full description) right under it; a pick sets the EXACT existing Infinite Options option (found by its own value) and
     closes the list. Anything unexpected = the dropdown overlay as before. ---------- */
  function desSplit(t) {
    var i = t.indexOf(' - '); if (i > 0) return [t.slice(0, i), t.slice(i + 3)];
    // round 3 (golf, "make nice"): "YES, A little help. (+$39.95) Help me make 18 flags…" -> name up to the price, the rest under it;
    // "YES. Design from scratch.  Quote me for…" -> name = first sentence(s) before the double space
    if (PAGE.custom) { var m = /^(.*?\(\+\$[\d.]+\))\s+(.+)$/.exec(t) || /^(.*?\.)\s{2,}(.+)$/.exec(t); if (m) return [m[1], m[2]]; }
    return [t, ''];
  }
  function renderDesign() {
    var sel = ioField(DES_NAME); if (!sel || sel.tagName !== 'SELECT') return false;
    var opts = [].filter.call(sel.options, function (o) { return !o.disabled && o.value; });
    if (opts.length < 2 || !sel.options[sel.selectedIndex]) return false;
    var field = sel.closest('[class*="spb-io-field"]'); if (!field || !sel.closest('.spb-option-values')) return false;
    var box = field.querySelector('.ff-des');
    if (!box) {
      box = D.createElement('div'); box.className = 'ff-des'; box.setAttribute('data-ff-proxy-for', DES_NAME);
      field.appendChild(box);
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        if (b.classList.contains('ff-des-cur')) {
          var open = !box.classList.contains('ff-des-open');
          box.classList.toggle('ff-des-open', open); b.setAttribute('aria-expanded', String(open)); return;
        }
        var s = ioField(DES_NAME), v = b.getAttribute('data-ff-value'); if (!s || v === null) return;
        var hit = [].filter.call(s.options, function (o) { return o.value === v; })[0]; if (!hit) return;
        if (s.value !== v) { s.value = v; fire(s); }
        box.classList.remove('ff-des-open');
        renderDesign();
        var c = box.querySelector('.ff-des-cur'); if (c) c.focus();
      });
      sel.addEventListener('change', function () { renderDesign(); });
    }
    var key = sel.value + '|' + opts.map(function (o) { return o.value; }).join('¦');
    if (box.getAttribute('data-key') !== key) {
      var open = box.classList.contains('ff-des-open'), cur = desSplit(sel.options[sel.selectedIndex].text);
      var h = '<button type="button" class="ff-des-cur" aria-expanded="' + open + '">' +
        '<svg class="ff-check" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M5 12l5 5L20 7" fill="none" stroke="currentColor" stroke-width="2.5"/></svg>' +
        '<span class="ff-des-name">' + esc(cur[0]) + '</span><span class="ff-des-change">Change</span>' +
        '<svg class="ff-chev" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"/></svg></button>' +
        '<div class="ff-des-list" role="radiogroup" aria-label="Design help">';
      opts.forEach(function (o) {
        var p = desSplit(o.text), on = o.value === sel.value;
        h += '<button type="button" role="radio" aria-checked="' + on + '" class="ff-row ff-des-opt' + (on ? ' ff-on' : '') + '" data-ff-value="' + esc(o.value) + '">' +
          '<span class="ff-row-main"><b>' + esc(p[0]) + '</b>' + (p[1] ? '<span class="ff-des-sub">' + esc(p[1]) + '</span>' : '') + '</span></button>';
      });
      box.innerHTML = h + '</div>'; box.setAttribute('data-key', key);
    }
    var lb = field.querySelector('label'); setText(lb, 'Design help'); if (lb) lb.setAttribute('data-ff-step', PAGE.desStep || '5');
    field.classList.add('ff-des-ready', 'ff-card');
    return true;
  }

  /* ---------- 4. Artwork + notes in one box; date label shortened ---------- */
  function renderArt() {
    var ta = ioField(NOTES_NAME), up = D.getElementById('uploadery-container');
    // club flags: no notes box and no upload (finished art), but the need-by date gets the same tap row as the other pages
    if (!ta || !up) { if (PAGE.noArt) renderDate(); return; }
    var field = ta.closest('[class*="spb-io-field"]'); if (!field) return;
    var box = D.getElementById('ff-art');
    if (!box) {
      box = D.createElement('div'); box.id = 'ff-art'; box.className = 'ff-card';
      // Artwork tips: Todd's approved wording (2026-10-16, "I like that drafting. That's great." + his edits)
      // v4 (Todd 2026-10-16): notes FIRST, then the upload ("some people are just going to want to describe their flag");
      // the "No file yet? Add to cart now and send it later." line and the mock-up line are gone ("too much clutter there").
      box.innerHTML = '<p class="ff-h" data-ff-step="' + (PAGE.artStep || '6') + '">Your artwork and design notes</p><div class="ff-art-card"><p class="ff-art-sub">Your artwork</p>' +
        // Todd 2026-10-16: "If you have more than two images for the flag, please email them to us after your order" -> "They should email it to design@FestFlags.com" then "No, info is fine. Sorry."
        '<details class="ff-tips"><summary>Artwork tips: file types, AI art</summary><div class="ff-tips-body">' +
        '<p><b>What files work best?</b><br>Adobe Illustrator (.ai), EPS or PDF print sharpest at any size. High-res JPG or PNG work too.</p>' +
        '<p><b>Can I use AI art (ChatGPT, Gemini, Midjourney and others)?</b><br>Yes! AI art can look incredible on a flag. AI images are made of pixels, so on flags 2 × 3 ft and bigger, depending on the image, the very finest details can soften a little. That’s normal, and the overall look still pops. We check every file and email you a mock-up before anything is printed. Want it sharper? Our design team can clean it up.</p></div></details>' +
        '<details class="ff-tips ff-extra-art"><summary>More than 2 images?</summary><div class="ff-tips-body"><p>Upload your main ones here, then email the rest to <a href="mailto:info@festflags.com">info@festflags.com</a> after you order. Put your order number in the subject.</p></div></details></div>';
      field.parentNode.insertBefore(box, field);
    }
    var card = box.querySelector('.ff-art-card'), sub = card.querySelector('.ff-art-sub');
    // order inside the card: notes field, "Your artwork", Uploadery's box, tips (each move only when out of place)
    if (card.firstChild !== field) card.insertBefore(field, card.firstChild);
    if (field.nextSibling !== sub) card.insertBefore(sub, field.nextSibling);
    if (sub.nextSibling !== up) card.insertBefore(up, sub.nextSibling);
    var forms = up.querySelectorAll('form');
    [].forEach.call(forms, function (f, i) {
      var lab = f.querySelector('label'); if (!lab) return;
      lab.classList.add('ff-up-label');
      if (!lab.querySelector('.ff-up-title')) {
        var s = D.createElement('span'); s.className = 'ff-up-title';
        // round 3: golf has a third Uploadery box ("Please email additional images…")
        s.textContent = i === 0 ? 'Front artwork' : i === 1 ? 'Back artwork' : 'More artwork';
        lab.insertBefore(s, lab.firstChild);
      }
    });
    var img2 = D.getElementsByName('properties[Image-2]')[0];
    // audit 1: never hide the back box while a back image is attached (it would still be sent); live shows it always
    // round 3: teardrop's sides are an Infinite Options box ("# of Sides Printed"); golf keeps both boxes always (18 flags, often
    // several sponsor logos: the live page shows both, so nothing is hidden there)
    var sf = PAGE.sidesField ? ioField(PAGE.sidesField) : null;
    card.classList.toggle('ff-double', !!PAGE.twoArt || cur().sides === 'Double Sided' || !!(sf && /^Double/i.test(sf.value)) || !!(img2 && img2.value));
    setText(field.querySelector('label'), 'Tell our designers what you want');
    var ph = "Background color, text and font, where the logo goes, anything else that matters to you. Our design team sends you a first draft within 3-24 hours, and you can make changes until it's 100% right.";
    if (ta.placeholder !== ph) ta.placeholder = ph;
    field.classList.add('ff-notes');
    renderDate();
  }
  function renderDate() {
    var dt = ioField(DATE_NAME), df = dt && dt.closest('[class*="spb-io-field"]');
    if (df) {
      // v4 (Todd 2026-10-16: "Does it notify them that they need to select the correct shipping speed at checkout? Is that
      // blatant on there?"): one tap row that opens Infinite Options' OWN date box (the same plain text box, never a copy)
      // with a yellow notice. The label stays (for screen readers) but is visually hidden; the row's button opens the box.
      // The button carries data-ff-proxy-for so the cart check counts the box as reachable (same field, visible control).
      setText(df.querySelector('label'), 'Need it by a certain date? (optional)');
      df.classList.add('ff-date', 'ff-card');
      var tg = df.querySelector('.ff-date-toggle');
      if (!tg) {
        tg = D.createElement('button'); tg.type = 'button'; tg.className = 'ff-date-toggle'; tg.setAttribute('aria-expanded', 'false');
        tg.setAttribute('data-ff-proxy-for', DATE_NAME);
        tg.innerHTML = '<span class="ff-date-q">Need it by a certain date?</span><span class="ff-date-opt">Optional</span><span class="ff-date-pm" aria-hidden="true"></span>';
        df.insertBefore(tg, df.firstChild);
        tg.addEventListener('click', function () {
          var open = !df.classList.contains('ff-date-open');
          df.classList.toggle('ff-date-open', open); tg.setAttribute('aria-expanded', String(open));
          var d2 = ioField(DATE_NAME); if (open && d2) d2.focus();
        });
        var note = D.createElement('div'); note.className = 'ff-date-note'; note.setAttribute('role', 'note');
        note.innerHTML = '<b>Important: pick the matching shipping speed at checkout.</b> The date tells us your deadline. The shipping speed you choose at checkout is what gets it to you in time.';
        df.appendChild(note);
      }
      // a date already in the box (typed earlier, or restored by the browser on Back) keeps the row open
      if (dt.value && !df.classList.contains('ff-date-open')) { df.classList.add('ff-date-open'); tg.setAttribute('aria-expanded', 'true'); }
    }
  }

  /* ---------- upload progress bar (Todd 2026-10-16: "some sort of ticker indicating that the upload is going on ...
     Something very simple but exciting to display movement"). Uploadery does not report real progress to the page, so
     the bar shows an estimated percent that keeps moving (see v5 below) and jumps to 100% when Uploadery's own hidden
     properties[Image-N] field gets its (new) value. Display only: it never touches a form field. ---------- */
  function watchUploads() {
    var up = D.getElementById('uploadery-container'); if (!up || up.getAttribute('data-ff-progress')) return;
    up.setAttribute('data-ff-progress', '1');
    up.addEventListener('change', function (e) {
      var inp = e.target; if (!inp || inp.type !== 'file' || !inp.files || !inp.files.length) return;
      var form = inp.closest('form'), forms = [].slice.call(up.querySelectorAll('form')), slot = forms.indexOf(form);
      if (!form || slot < 0) return;
      var name = 'properties[Image-' + (slot + 1) + ']';
      var cur0 = D.getElementsByName(name)[0], before = cur0 ? cur0.value : '';
      var bar = form.querySelector('.ff-up-progress');
      if (!bar) {
        bar = D.createElement('div'); bar.className = 'ff-up-progress';
        bar.innerHTML = '<div class="ff-up-track"><div class="ff-up-fill"></div></div><span class="ff-up-status" aria-live="polite"></span>';
        form.appendChild(bar);
      }
      var fill = bar.querySelector('.ff-up-fill'), status = bar.querySelector('.ff-up-status'), pct = 2, t0 = Date.now();
      // v5 (Todd 2026-10-16: "The power meter for the artwork upload does not show a percentage. It should be constantly
      // growing so it looks like there's movement."). Uploadery gives no real progress, so the percent is an ESTIMATE from
      // the file size (~300 KB/s, 4-120 s): steady to 90% by then, then it keeps creeping toward 99% (never stops moving);
      // 100% only when Uploadery's own field gets the file's link.
      var est = Math.min(120, Math.max(4, (inp.files[0].size || 0) / 300000));
      var show = function (p, txt) { fill.style.width = p.toFixed(1) + '%'; bar.setAttribute('aria-valuenow', String(Math.round(p))); status.textContent = txt.replace('#', Math.floor(p) + '%'); };
      bar.className = 'ff-up-progress ff-up-busy';
      bar.setAttribute('role', 'progressbar'); bar.setAttribute('aria-valuemin', '0'); bar.setAttribute('aria-valuemax', '100');
      show(pct, 'Uploading… #');
      if (bar._ffTimer) clearInterval(bar._ffTimer);
      bar._ffTimer = setInterval(function () {
        var el = D.getElementsByName(name)[0], v = el ? el.value : '';
        if (!bar.isConnected) form.appendChild(bar);
        if (v && v !== before) {
          clearInterval(bar._ffTimer); bar.className = 'ff-up-progress ff-up-done'; show(100, '✓ Uploaded · 100%');
          return;
        }
        var secs = (Date.now() - t0) / 1000;
        pct = secs < est ? 2 + 88 * (secs / est) : 90 + 9 * (1 - Math.exp(-(secs - est) / 45));
        show(pct, secs > 60 ? 'Still uploading… # · large files can take a minute' : 'Uploading… #');
        if (secs > 300) { clearInterval(bar._ffTimer); bar.className = 'ff-up-progress'; status.textContent = ''; fill.style.width = '0'; }
      }, 200);
    }, true);
  }

  /* ---------- 1. Phone Add to cart bar (clicks the REAL button) ---------- */
  var io = null, watched = null;
  function realButton() {
    var bs = D.querySelectorAll('form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] button[type="submit"]');
    for (var i = 0; i < bs.length; i++) { var r = bs[i].getBoundingClientRect(); if (r.width > 0 && r.height > 0) return bs[i]; }
    return null;
  }
  function renderSticky() {
    var real = realButton(); if (!real) return;
    var bar = D.getElementById('ff-sticky');
    if (!bar) {
      bar = D.createElement('div'); bar.id = 'ff-sticky'; bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<div class="ff-sticky-info"><b class="ff-sticky-price"></b><span class="ff-sticky-sub"></span></div><button type="button" class="ff-sticky-btn" tabindex="-1">Add to cart</button>';
      D.body.appendChild(bar);
      bar.querySelector('button').addEventListener('click', function () {
        var r = realButton(); if (!r) return;
        if (r.disabled) { r.scrollIntoView({ block: 'center' }); return; }
        r.click();
      });
    }
    var c = cur(), v = variantFor(c.size, c.sides);
    var tp = D.querySelector('[id^="price-template"] .price__regular .price-item--regular, [id^="price-template"] .price-item');
    var addCents = 0;
    if (PAGE.barAddons && v && isUSD()) {
      // each picked add-on's own price as its label shows it ("{+$65.95}", "{+45.95}", "(+$9.95)"); checked 2026-10-20 = the add-on prices charged
      PAGE.barAddons.forEach(function (n) {
        var f = ioField(n), m = f && String(f.value).match(/[{(]\s*\+\s*\$?\s*([\d.]+)\s*[})]/);
        if (m) addCents += Math.round(parseFloat(m[1]) * 100);
      });
    }
    setText(bar.querySelector('.ff-sticky-price'), v ? (addCents ? moneyDiff(v.price + addCents) : priceText(v)) : (tp ? tp.textContent.trim() : ''));
    var sp2 = shapeParts(c.size), sfv = PAGE.sidesField ? ioField(PAGE.sidesField) : null;
    var sideTxt = c.sides === 'Double Sided' ? 'double-sided' : c.sides === 'Single Sided' ? 'single-sided' : sfv ? (/^Double/i.test(sfv.value) ? 'double-sided' : 'single-sided') : String(c.sides || '');
    setText(bar.querySelector('.ff-sticky-sub'), addCents ? 'incl. ' + moneyDiff(addCents) + ' add-ons' :   // short enough to fit a phone bar ("Flag $… + add-ons $…" was cut off at 375 px)
      c.size ? (sp2 ? sp2.shape + ' ' + sp2.size.toLowerCase() : sizeLabel(c.size)) + (sideTxt ? ' · ' + sideTxt : '') : '');
    bar.querySelector('button').disabled = !!real.disabled;
    if (watched !== real && 'IntersectionObserver' in window) {
      if (io) io.disconnect();
      io = new IntersectionObserver(function (en) {
        bar.classList.toggle('ff-hide', en[0].isIntersecting);
        D.documentElement.classList.toggle('ff-bar-shown', !en[0].isIntersecting);
      });
      io.observe(real); watched = real;
    }
    D.documentElement.classList.add('ff-sticky-on');
  }

  /* ---------- top bullets: SAME words, one line each on a phone (Todd 2026-10-16: "I like the bullet points and the
     verbiage that we already have ... Why can't we just change the look of it so it fits?"). Each line (the metafield
     text between <br>s) gets its own span; on a phone it is shrunk only as far as needed to fit, never below 11 px;
     if it still does not fit it wraps (never cut off). Words untouched. ---------- */
  function fitBullets() {
    var box = D.querySelector('.ff-top-bullets'), p = box && box.querySelector('p'); if (!p) return;
    if (!p.querySelector('.ff-bl')) {
      var lines = [], cur1 = [];
      [].slice.call(p.childNodes).forEach(function (n) { if (n.nodeName === 'BR') { lines.push(cur1); cur1 = []; } else cur1.push(n); });
      if (cur1.length) lines.push(cur1);
      lines = lines.filter(function (ns) { return ns.some(function (n) { return (n.textContent || '').trim(); }); });
      if (lines.length < 2) return;
      while (p.firstChild) p.removeChild(p.firstChild);
      lines.forEach(function (ns) {
        var sp = D.createElement('span'); sp.className = 'ff-bl';
        ns.forEach(function (n, i) { if (i === 0 && n.nodeType === 3) n.textContent = n.textContent.replace(/^\s+/, ''); sp.appendChild(n); });
        p.appendChild(sp);
      });
    }
    var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var spans = p.querySelectorAll('.ff-bl'), need = 99;
    [].forEach.call(spans, function (sp) { sp.style.fontSize = ''; sp.classList.remove('ff-bl-wrap'); });
    if (!phone) return;
    // the size each line needs to fit; then ALL lines use the smallest of those (one even look), never below 11 px
    [].forEach.call(spans, function (sp) {
      var fs = parseFloat(getComputedStyle(sp).fontSize) || 14, guard = 0;
      while (sp.scrollWidth > sp.clientWidth + 0.5 && fs > 11 && guard++ < 40) { fs = Math.max(11, fs - 0.25); sp.style.fontSize = fs + 'px'; }
      need = Math.min(need, fs);
    });
    [].forEach.call(spans, function (sp) {
      sp.style.fontSize = need + 'px';
      if (sp.scrollWidth > sp.clientWidth + 0.5) sp.classList.add('ff-bl-wrap');   // audit 5: wraps at the SAME shared size
    });
  }

  /* ---------- price row: "Shipping calculated at checkout" + Shop Pay line to the RIGHT of the price (Todd 2026-10-16,
     "can that be moved to the right of the price so we can bring everything up a little bit?"). The theme keeps updating
     each piece by its own id, wherever it sits. If any piece is missing, nothing is moved. ---------- */
  function renderPriceRow() {
    // Todd 2026-10-18: "the shipping calculated at checkout should be under add to cart. Its clogging the area up there"
    // -> the theme's own "Shipping calculated at checkout." line is moved to just under the Add to cart button (display only;
    // it holds no form field). If the button box is not found, it stays where the theme put it.
    var tax = D.querySelector('.product__info-container .product__tax');
    var buttons = D.querySelector('.product__info-container product-form .product-form__buttons');
    if (tax && buttons && buttons.nextElementSibling !== tax) { tax.classList.add('ff-tax-under'); buttons.insertAdjacentElement('afterend', tax); }
    var price = D.querySelector('.product__info-container [id^="price-template"]'); if (!price) return;
    var row = D.getElementById('ff-price-row');
    if (row && row.contains(price)) return;
    var terms = D.querySelector('.product__info-container form[id^="product-form-installment"]');
    var termsBox = terms && terms.parentElement && terms.parentElement.parentElement === price.parentElement ? terms.parentElement : terms;
    if (!termsBox) return;
    row = D.createElement('div'); row.id = 'ff-price-row';
    price.parentNode.insertBefore(row, price);
    var right = D.createElement('div'); right.className = 'ff-price-side';
    row.appendChild(price); row.appendChild(right); right.appendChild(termsBox);
  }

  /* ---------- run (idempotent; re-run after the theme or the apps redraw) ---------- */
  function applyAll() {
    try {
      var ok = renderVariantUI();
      var c = cur(), vk = c.size + '|' + c.sides;
      // audit 1: only record the size/sides once the STITCHING box exists, so a page opened on a ?variant= link
      // (ads, Google Shopping, reload, Back) still gets the pre-pick when Infinite Options finishes loading.
      if (ok && vk !== state.lastVariantKey && ioField(ST_NAME)) { state.lastVariantKey = vk; applyRecommended(); }
      if (PAGE.custom) {
        PAGE.tiles.forEach(renderTiles);
        if (PAGE.finClassic && !renderFinish()) overlay(FIN_NAME, null, false, '4');
      } else {
        renderStitch();
        if (!renderFinish()) overlay(FIN_NAME, null, false, '4');
      }
      // round 3 audit 1 (REJECT): the golf note check sits AFTER the if/else above (it had split them, so the classic stitching /
      // finishing code ran on the tile pages too)
      if (PAGE.sizeNoteWhen) {
        var snf = ioField(PAGE.sizeNoteWhen.field), sn = D.querySelector('#ff-variant-ui .ff-size-note');
        if (sn) sn.hidden = !(snf && PAGE.sizeNoteWhen.re.test(snf.value));
      }
      if (!renderDesign()) {
        // audit 7: an accordion drawn earlier must not stay (with stale choices) over a hidden dropdown: take it away first
        [].forEach.call(D.querySelectorAll('.ff-des'), function (b) { b.parentNode.removeChild(b); });
        [].forEach.call(D.querySelectorAll('.ff-des-ready'), function (f) { f.classList.remove('ff-des-ready'); });
        overlay(DES_NAME, 'Design help', true, PAGE.desStep || '5');
      }
      renderArt();
      renderSticky();
      renderPriceRow();
      watchUploads();
      D.documentElement.classList.add('ff-clean');
    } catch (e) { console.warn('[ff-clean] skipped a part; classic controls stay where it failed', e); }
  }
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(applyAll, 60); }
  function start() {
    applyAll();
    try { fitBullets(); if (D.fonts && D.fonts.ready) D.fonts.ready.then(fitBullets); } catch (e) { console.warn('[ff-clean] bullets left as they were', e); }
    var rt = null; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { try { fitBullets(); } catch (e) {} }, 150); });
    var info = D.querySelector('.product__info-container');
    if (info && 'MutationObserver' in window) new MutationObserver(schedule).observe(info, { childList: true, subtree: true });
    D.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-selects')) { if (e.isTrusted) state.touched = true; schedule(); } });
    var n = 0, poll = setInterval(function () { n++; applyAll(); if ((ioField(READY_NAME) && D.getElementById('uploadery-container') && realButton()) || n > 60) clearInterval(poll); }, 300);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
})();
